<template>
    <div
        id="be-login"
        class="schermata-form pagina-vetrina"
    >
        <!--classe pagina-vetrina perchè deve esserci l'header delle pagine vetrina)-->
        <div class="body-wrapper">
            <gallery-header header='LOGIN' />

            <div class="clearfix" />

            <div class="d-flex justify-content-center align-items-center flex-wrap mx-auto py-4 px-2">
                <main
                    v-if="!showDomainSelection"
                    class="w-100 p-0"
                >
                    <div class="form-container bg-white rounded p-3">
                        <h1 class="mb-0 text-uppercase text-center">{{ $t("Login") }}</h1>
                        <div class="mt-1 text-center">
                            <span class="font-titoli-rikorda">Accedi con le tue credenziali di fotografo Rikorda:</span>
                            <br />
                            <small>(PRF..., URF..., ERF..., MVF..., ecc)</small>
                        </div>
                        <form
                            action
                            method="post"
                            class="mt-3"
                            @submit.prevent="onSubmit"
                            v-show="!isRecoveringPassword && !recoveryPasswordSent"
                        >
                            <div class="form-group mb-0">
                                <label for="username">{{
                                    $t("Nome utente")
                                }}</label>
                                <input
                                    type="username"
                                    name="username"
                                    class="form-control rounded-pill rilievo-ombra-interna"
                                    :placeholder="$t('Nome utente')"
                                    id="username"
                                    v-model="username"
                                />
                            </div>
                            <div class="form-group mb-0 mt-3">
                                <label for="password">{{
                                    $t("Password")
                                }}</label>
                                <input
                                    type="password"
                                    name="password"
                                    class="form-control rounded-pill rilievo-ombra-interna"
                                    :placeholder="$t('Password')"
                                    id="password"
                                    v-model="password"
                                />
                            </div>
                            <div class="text-right mb-0 mt-3">
                                <a
                                    href=""
                                    @click.prevent="onForgotPassword"
                                >
                                    {{ $t("Password dimenticata?") }}
                                </a>
                            </div>
                            <!--div class="form-check mb-0 mt-3">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value
                                    id="ricorda-login"
                                    v-model="rememberMe"
                                />
                                <label
                                    class="form-check-label"
                                    for="ricorda-login"
                                    >{{ $t("Ricordami") }}</label
                                >
                            </div-->
                            <span
                                v-if="error"
                                class="text-danger"
                            >
                                {{ errorMessage }} <span v-if="retryAfter>0">
                                    {{$t('Riprova tra ')}}{{retryAfter}}{{$t(' secondi')}}</span>
                            </span>
                            <div class="mb-0 mt-3 text-center">
                                <button
                                    type="submit"
                                    class="pulsante-login btn btn-primary btn-rikorda1 btn-icon-right"
                                    :disabled="retryAfter>0"
                                >
                                    {{ $t("Login") }}
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                </button>
                            </div>
                            <div class="mt-3">
                                <router-link :to="{ name: 'page-request-contact' }">
                                    {{ $t("Non sei ancora registrato come Fotografo Rikorda?") }}
                                </router-link>
                            </div>
                        </form>
                        <form
                            ref="loginForm"
                            action
                            method="post"
                            class="mt-3"
                            @submit.prevent="onRememberPassword"
                            v-show="isRecoveringPassword && !recoveryPasswordSent"
                        >
                            <div class="form-group mb-0">
                                <label for="username-recover-pwd"></label>
                                <input
                                    type="text"
                                    name="username"
                                    class="form-control rounded-pill rilievo-ombra-interna"
                                    :placeholder="$t('Nome utente')"
                                    id="username-recover-pwd"
                                    v-model="username"
                                />
                            </div>
                            <div class="mt-3 text-center">
                                {{$t('Se hai dimenticato la tua password, inserisci il tuo username e clicca su "Invia".')}}
                                {{$t('Ti verrà inviata una e-mail per modificare la password.')}}
                            </div>
                            <div class="mb-0 mt-3 text-center">
                                <button
                                    type="submit"
                                    class="pulsante-login btn btn-primary btn-rikorda1"
                                    @click.prevent="onRecoverPassword()"
                                >
                                    {{ $t("Invia") }}
                                </button>
                            </div>
                            <div>
                                <a
                                    href=""
                                    @click.prevent="onLogin"
                                >
                                    {{ $t("Login") }}
                                </a>
                            </div>
                        </form>
                        <div
                            v-show="recoveryPasswordSent"
                            class="mt-3 text-center"
                        >
                            <p>{{$t('Ti abbiamo inviato una mail che ti consentirà di reimpostare la password.')}}</p>
                            <button
                                type="button"
                                class="pulsante-login btn btn-primary btn-rikorda1"
                                @click.prevent="onLogin"
                            >
                                {{ $t("Login") }}
                            </button>
                        </div>
                    </div>
                </main>

                <!-- SE IL FOTOGRAFO NON HA IL DOMINIO ASSOCIATO -->
                <main
                    v-else
                    class="w-100 p-0"
                >
                    <div class="form-container bg-white rounded p-3">
                        <h1 class="mb-0 text-center">{{ $t("Richiedi il tuo indirizzo internet") }}</h1>
                        <div class="mt-1 justify-content-start">
                            <small>
                                Per utilizzare RikordaEventi devi avere indirizzo internet di store RikordaEventi.
                                Dal momento che non ne hai ancora uno, inserisci il nome dello store che desideri e,
                                se non è già stato assegnato ad altro fotografo, provvederemo subito ad assegnarlo a te!
                            </small>
                        </div>
                        <div class="mt-3">
                            <span class="font-titoli-rikorda">Inserisci il nome store che desideri:</span>
                        </div>
                        <validation-observer
                            v-slot="{handleSubmit}"
                            tag="form"
                        >
                            <fieldset>
                                <div class="form-group mb-0 text-center">
                                    <validation-provider
                                        :rules="{ required: true, min: 3, max: 80, regex: /^[a-z0-9\-]+$/ }"
                                        v-slot="{ errors }"
                                        tag="div"
                                        class="custom-control mt-1 mr-0 pl-0"
                                    >
                                        <span>https://</span>
                                        <input
                                            type="text"
                                            name="storename"
                                            class="form-control d-inline w-50 rounded-pill rilievo-ombra-interna"
                                            id="storename"
                                            v-model="storename"
                                            @focus="resetStorenameErrorMsg"
                                        /><span>.rikordaeventi.it</span>
                                        <br /><small class="text-danger">{{errors[0] || storenameErrorMsg}}</small>
                                    </validation-provider>
                                </div>
                            </fieldset>

                            <div class="mb-0 mt-5 text-center">
                                <button
                                    class="pulsante-login btn btn-primary btn-rikorda1 btn-icon-right"
                                    @click.prevent="handleSubmit(onSubmitStoreName)"
                                >
                                    {{ $t("Continua") }}
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                </button>
                            </div>
                        </validation-observer>
                    </div>
                </main>
            </div>

            <gallery-footer />
        </div>

        <b-modal
            id="gdpr-wizard"
            size="xl"
            scrollable
            hide-footer
            :title="gdprWizardTitle"
        >
            <BackendWizardGDPR
                :shop="shopData"
                :hasConfirmedDoc="hasConfirmedDoc"
                :gdpr="gdpr"
                :countryList="countryList"
                :provincesList="provincesList"
                :citiesList="citiesList"
                :zipList="zipList"
                @updateTitle="onUpdateTitle"
                @close="onWizardGDPRClose"
                @gdprAccepted="onWizardGDPRAccept"
            />
        </b-modal>

    </div>
</template>

<script>
import BackendWizardGDPR from "../../components/backend/WizardGDPR";
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, regex, min, max } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Inserisci un nome per il tuo store"
});
extend("min", {
    ...min,
    message: "Il nome dev'essere composto da almeno 3 caratteri alfa numerici."
});
extend("max", {
    ...max,
    message:
        "Il nome dev'essere composto da al massimo 80 caratteri alfa numerici."
});
extend("regex", {
    ...regex,
    message:
        "Il nome immesso contiene caratteri non ammessi (usare solo caratteri alfa numerici)."
});

export default {
    name: "BackendLogin",

    components: {
        BackendWizardGDPR,
        GalleryHeader,
        GalleryFooter,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            showDomainSelection: false,
            username: null,
            password: null,
            storename: null,
            rememberMe: false,
            error: false,
            errorMessage: null,
            storenameErrorMsg: null,
            retryAfter: 0,
            isRecoveringPassword: false,
            recoveryPasswordSent: false,
            hasToAcceptGdpr: false,
            hasConfirmedDoc: false,
            gdpr: {},
            shopData: null,
            countryList: [
                { id: null, name: "Seleziona nazione" },
                { id: "Italia", name: "Italia" }
            ],
            provincesList: [],
            citiesList: {},
            zipList: [],
            gdprWizardTitle: "",
            redirectUrl: null
        };
    },

    methods: {
        onUpdateTitle(title) {
            this.gdprWizardTitle = title;
        },
        onWizardGDPRClose() {
            this.$bvModal.hide("gdpr-wizard");
        },
        onWizardGDPRAccept() {
            if (this.$gtm) {
                this.$gtm.push({ event: "sign_up" });
            }
            this.$nextTick(() => {
                this.onSubmit();
            });
        },
        onSubmit() {
            this.$store
                .dispatch("BACKEND_LOGIN", {
                    username: this.username,
                    password: this.password,
                    rememberMe: this.rememberMe
                })
                .then((response) => {
                    console.debug("BACKEND_LOGIN", response);

                    // resetta la vista in caso venga dalla selezione dominio
                    this.showDomainSelection = false;

                    if (response.redirect) {
                        console.debug("REDIRECT", response, this.redirect);
                        var params = {
                            token: response.token,
                            user: response.user
                        };
                        this.redirectUrl =
                            response.redirect +
                            this.resolveUrl({
                                name: "backend-dashboard",
                                query: {
                                    bl: btoa(JSON.stringify(params))
                                }
                            });
                    }

                    if (this.$store.getters.hasAcceptedGDPR) {
                        if (this.redirectUrl) {
                            window.location.href = this.redirectUrl;
                        } else {
                            this.$router.push({ name: "backend-dashboard" });
                        }
                    } else {
                        this.hasConfirmedDoc = response.hasConfirmedDoc;
                        this.gdpr = response.docs;
                        this.shopData = response.shopData;
                        this.provincesList = response.provinces.provinces;
                        this.citiesList = response.cities.cities;
                        this.zipList = this.citiesList[this.shopData.citta];
                        this.$bvModal.show("gdpr-wizard");
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_LOGIN", error);
                    this.error = true;

                    if (
                        typeof error === "object" &&
                        error.response.status === 429
                    ) {
                        this.retryAfter = +error.response.headers[
                            "retry-after"
                        ];
                        this.errorMessage = this.$t(
                            "Troppi tentativi effettuati."
                        );
                        this.countDownTimer();
                    } else {
                        switch (error) {
                            case "domain not found":
                                this.showDomainSelection = true;
                                break;
                            default:
                                this.errorMessage = this.$t(error);
                                break;
                        }
                    }
                });
        },

        onForgotPassword() {
            this.isRecoveringPassword = true;
        },

        onRecoverPassword() {
            return this.$api
                .backendResetPassword(this.username)
                .then(() => {
                    this.recoveryPasswordSent = true;
                })
                .catch((error) => {
                    alert("Recupera password: errore. Riprovare");
                    console.error(error);
                });
        },

        onLogin() {
            this.isRecoveringPassword = false;
            this.recoveryPasswordSent = false;
        },

        countDownTimer() {
            if (this.retryAfter > 0) {
                setTimeout(() => {
                    this.retryAfter -= 1;
                    this.countDownTimer();
                }, 1000);
            } else {
                this.resetErrorMessage();
            }
        },

        resetErrorMessage() {
            this.error = false;
            this.errorMessage = "";
        },

        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        },

        resetStorenameErrorMsg() {
            this.storenameErrorMsg = "";
        },

        onSubmitStoreName() {
            if (this.username && this.password) {
                this.$api
                    .backendAssignStoreName(
                        this.username,
                        this.password,
                        this.storename
                    )
                    .then((response) => {
                        console.debug("BACKEND_ASSIGN_STORE_NAME", response);
                        // ripete la login con i dati inseriti in precedenza
                        this.$nextTick(() => {
                            this.onSubmit();
                        });
                    })
                    .catch((error) => {
                        console.error("BACKEND_ASSIGN_STORE_NAME", error);
                        this.storenameErrorMsg = "Nome store già assegnato";
                    });
            }
        }
    },

    computed: {
        logoUrl() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.logoUrl ? shopData.logoUrl : "";
        },
        isGlobalSite() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.isGlobalSite;
        }
    }
};
</script>

<style scoped>
.schermata-form .body-wrapper > div:not(.clearfix) {
    margin-top: calc(2rem + 96px);
}
@media print {
    body * {
        visibility: hidden;
    }
}
</style>
